import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TrueFalseExample;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint-disable react/jsx-no-literals */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import TrueFalseEdit from '../Edit';
import TrueFalseShow from '../Show';
import TrueFalseTake from '../Take';
import TrueFalseResult from '../Result';
import generateStyle from '../../common/example/default';
import generateComponentTheme from '../../common/example/defaultTheme';
import { withStyleOverrides } from '@instructure/quiz-common';

/**
---
category: TrueFalse
---
  TrueFalse Example.

  ```jsx_example
    <SettingsSwitcher locales={LOCALES}>
      <TrueFalseExample />
    </SettingsSwitcher>
  ```
**/
var TrueFalseExample = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TrueFalseExample = /*#__PURE__*/function (_Component) {
  function TrueFalseExample(props) {
    var _this;
    _classCallCheck(this, TrueFalseExample);
    _this = _callSuper(this, TrueFalseExample);
    _defineProperty(_this, "handleChangeItemState", function (itemState) {
      var newState = {};
      if (itemState.scoringData) {
        newState.scoredData = _this.transformScoredData(itemState.scoringData);
        newState.userResponse = _this.transformScoredData(itemState.scoringData);
      }
      if (itemState.interactionData) {
        newState.takeInteractionData = _this.transformTakeInteractionData(itemState.interactionData);
      }
      var updatedState = Object.assign({}, itemState, newState);
      _this.setState(updatedState);
    });
    _defineProperty(_this, "handleResponseUpdate", function (userResponse) {
      var stateUserResponse = {
        value: userResponse
      };
      _this.setState({
        userResponse: stateUserResponse,
        scoredData: _this.transformScoredData(_this.state.scoringData, stateUserResponse)
      });
    });
    _this.state = {};
    if (props.useDefaultData) {
      Object.assign(_this.state, {
        itemBody: 'The sun is a star',
        interactionData: {
          trueChoice: 'True',
          falseChoice: 'False'
        },
        scoringData: {
          value: true
        },
        scoredData: {},
        userResponse: {}
      });
      _this.state.scoredData = _this.transformScoredData(_this.state.scoringData);
      _this.state.takeInteractionData = _this.transformTakeInteractionData(_this.state.interactionData);
    }
    return _this;
  }
  _inherits(TrueFalseExample, _Component);
  return _createClass(TrueFalseExample, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        scoredData: this.transformScoredData(this.state.scoringData)
      });
    }

    /**
     * Normally, this should be calling a service
     */
  }, {
    key: "transformScoredData",
    value: function transformScoredData(scoringData) {
      var userResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.userResponse;
      return {
        correct: scoringData.value === userResponse.value,
        value: {
          "true": {
            resultScore: scoringData.value ? 1 : 0,
            userResponded: userResponse.value === true
          },
          "false": {
            resultScore: scoringData.value ? 0 : 1,
            userResponded: userResponse.value === false
          }
        }
      };
    }

    /**
     * Normally, this should be calling a service
     */
  }, {
    key: "transformTakeInteractionData",
    value: function transformTakeInteractionData(interactionData) {
      return cloneDeep(interactionData);
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      return jsx("div", {
        title: "edit"
      }, jsx(Heading, {
        level: "h2"
      }, "Edit"), jsx(TrueFalseEdit, {
        changeItemState: this.handleChangeItemState,
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody,
        itemId: this.state.itemId,
        properties: this.state.properties,
        scoringData: this.state.scoringData
      }));
    }
  }, {
    key: "renderShow",
    value: function renderShow() {
      return jsx("div", {
        title: "show"
      }, jsx(Heading, {
        level: "h2"
      }, "Show"), jsx(TrueFalseShow, {
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody,
        itemId: this.state.itemId,
        properties: this.state.properties,
        scoringData: this.state.scoringData
      }));
    }
  }, {
    key: "renderTake",
    value: function renderTake() {
      return jsx("div", {
        title: "take"
      }, jsx(Heading, {
        level: "h2"
      }, "Take"), jsx(TrueFalseTake, {
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        userResponse: this.state.userResponse,
        handleResponseUpdate: this.handleResponseUpdate
      }));
    }

    // FIXME: the props should be scoredData here
  }, {
    key: "renderResult",
    value: function renderResult() {
      return jsx("div", {
        title: "result"
      }, jsx(Heading, {
        level: "h2"
      }, "Result"), jsx(TrueFalseResult, {
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        userResponse: this.state.userResponse,
        scoredData: this.state.scoredData
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderEdit()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderShow())), jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderTake()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderResult())));
    }
  }]);
}(Component), _defineProperty(_TrueFalseExample, "displayName", 'TrueFalseExample'), _defineProperty(_TrueFalseExample, "componentId", "Quizzes".concat(_TrueFalseExample.displayName)), _defineProperty(_TrueFalseExample, "propTypes", {
  useDefaultData: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_TrueFalseExample, "defaultProps", {
  useDefaultData: true
}), _TrueFalseExample)) || _class);
export { TrueFalseExample as default };